module.exports = __webpack_public_path__ + "img/Dantam Fashion 07.cf9a54a5.jpg";